import {
  GetSystemPropertyQuery,
  GetSystemPropertyQueryVariables,
  ListSystemPropertysQuery,
  ListSystemPropertysQueryVariables,
  getSystemProperty,
  graphqlCall,
  listSystemPropertys,
} from '@akin-home/amplify';
import { API } from 'aws-amplify';

export const listSystemPropertiesQuery = (
  params: ListSystemPropertysQueryVariables
) => graphqlCall<ListSystemPropertysQuery>(listSystemPropertys, params);

export const getSystemPropertyQuery = (
  params: GetSystemPropertyQueryVariables
) => graphqlCall<GetSystemPropertyQuery>(getSystemProperty, params);

export const getPublicSystemProperty = (name: string) =>
  API.get('systemPropertyAPI', '/system-property/' + name, {});
